module.exports = __webpack_public_path__ + "static/4-54a93f478ee459dc23bd215ce8c44aa1.png";